import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { Button } from '@mui/material';

import { HeaderAction } from '@app/components/ListHeaderActions';

interface ReorderButtonProps {
  action: HeaderAction;
}

export const ReorderButton = ({ action }: ReorderButtonProps) => {
  return (
    <Button
      data-cy="save_order"
      variant="outlined"
      color="primary"
      disabled={action.disabled}
      sx={{ marginLeft: 2 }}
      startIcon={<SaveAltIcon />}
      onClick={action.handler}>
      SAVE ORDER
    </Button>
  );
};
